module.exports = __webpack_public_path__ + "static/media/chatBubble.43608aed.svg";